import { render } from "./SafetyPoliciesUnauth.vue?vue&type=template&id=1ce07ccd"
import script from "./SafetyPoliciesUnauth.vue?vue&type=script&lang=js"
export * from "./SafetyPoliciesUnauth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__